export default 
  {
    orderID: 1,
    ponumber: "EAPE1354",
    clientname: "Armagh Harps GAA",
    orderDate: "1/9/2020",
    orderReference: "REF123",
    makeuplocation:"",
    productionlocation:"",
    artwork:"",
    garmentname:"Personalised Gaelic Jersey",
    garmentimage:"DIGI83171.jpg",
    status: "Awaiting Print"
  }
